// 是否是邮箱
export const isEmail = val => {
  let reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
  return reg.test(val)
}
// 是否是手机号
export const isPhone = val => {
  return /^1[0-9]{10}$/.test(val)
}
// 是否是正整数
export const isNum = val => {
  return /^[0-9]*$/.test(val)
}
// 是否是浮点数或正整数(浮点数必须两位)
export const isIntegerOrFloat = val => {
  return /^(([1-9]\d*)|0)(\.(\d){2})?$/.test(val)
}
// 必须是浮点数(1位)
export const isFloat1 = val => {
  return /^(([1-9]\d*)|0)(\.(\d){1})$/.test(val)
}
// 必须是浮点数(2位)
export const isFloat2 = val => {
  return /^(([1-9]\d*)|0)(\.(\d){2})$/.test(val)
}
// 是否是分号
export const isSemicolon = val => {
  return /^([1-9]+)\/{1}([1-9]+)$/.test(val)
}
// 校验百分号
export const isPercent = val => {
  return /^(([1-9]\d*)|0)(\.(\d){1,2})?%$/.test(val)
}

// 是否是汉字
export const isChinese = val => {
  return /[\u4E00-\u9FA5]/g.test(val)
}
// 单词数量
export const isExceedWords = (num, val) => {
  let wordsLength = num * 8
  return val.length > wordsLength
}
// 验证是否是手机号
export const validatePhone = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    if (!isPhone(value)) {
      callback(new Error('请输入正确的手机号'))
    } else {
      callback()
    }
  }
}
// 验证是否是整数
export const validateNumber = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    let min = rule.minNum || 0
    let max = rule.maxNum || 0
    if (!isNum(value)) {
      callback(new Error('请输入整数数字'))
    } else if ((min || max) && (value < min || value > max)) {
      callback(new Error(`请输入范围${min}-${max}`))
    } else {
      callback()
    }
  }
}
// 验证不能输入汉字
export const validateChinese = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    if (isChinese(value)) {
      callback(new Error('不能输入汉字'))
    } else {
      callback()
    }
  }
}
// 验证单词数量
export const validateWordsNum = (rule, value, callback) => {
  let wordsNum = rule.wordsNum
  if (!value) {
    callback()
  } else {
    if (isExceedWords(wordsNum, value)) {
      callback(new Error(`最多输入${wordsNum}个单词`))
    } else {
      callback()
    }
  }
}
// 校验是否是年份
export const validateYears = (rule, value, callback) => {
  let num = value
  if (!num) {
    callback()
  } else {
    if (!isNum(num)) {
      callback(new Error('请输入数字'))
    } else if (num.length !== 4) {
      callback(new Error('请输入四位格式的年份, 如:2018'))
    } else {
      callback()
    }
  }
}
// 校验是浮点数（默认校验一位）
export const validateFloat = (rule, value, callback) => {
  let num = value
  let floatLength = rule.floatLength
  if (!num) {
    callback()
  } else {
    if (!floatLength || floatLength === 1) {
      if (!isFloat1(num)) {
        callback(new Error('请输入浮点数（必须小数点后1位）'))
      } else {
        callback()
      }
    }
    if (floatLength === 2) {
      if (!isFloat2(num)) {
        callback(new Error('请输入浮点数（必须小数点后2位）'))
      } else {
        callback()
      }
    }
  }
}
// 校验必须是分号
export const validateSemicolon = (rule, value, callback) => {
  let num = value
  if (!num) {
    callback()
  } else {
    if (!isSemicolon(num)) {
      callback(new Error('请输入正确格式'))
    } else {
      callback()
    }
  }
}
// 校验百分号
export const validatePercent = (rule, value, callback) => {
  let num = value
  if (!num) {
    callback()
  } else {
    let min = rule.minNum || 0
    let max = rule.maxNum || 0
    let copyNum = num.toString().replace('%', '')
    if (!isPercent(num)) {
      callback(
        new Error('请输入正确格式必须含有%(可以有小数点，小数点后面1-2位)')
      )
    } else if ((min || max) && (copyNum < min || copyNum > max)) {
      callback(new Error(`请输入范围${min}%-${max}%`))
    } else {
      callback()
    }
  }
}
// 范围内容
export const validateRange = (rule, value, callback) => {
  let num = value
  let min = rule.minNum || 0
  let max = rule.maxNum || 0
  if (!num) {
    callback()
  } else if ((min || max) && (value < min || value > max)) {
    callback(new Error(`请输入范围${min}-${max}`))
  } else {
    callback()
  }
}
// 校验倍数
export const validateMultiple = (rule, value, callback) => {
  let num = value
  let multiple = Number(rule.multiple)
  if (!num || !multiple) {
    callback()
  } else {
    if (num % multiple !== 0) {
      callback(new Error(`请输入${multiple}倍数`))
    } else {
      callback()
    }
  }
}

// 验证必须是数字
export const validateNum = (rule, value, callback) => {
  if (!/^\d+(\.\d{1,2})?$/.test(value)) {
    callback(new Error('只能输入数字，小数点后只能保留两位'))
  } else {
    callback()
  }
}
